// extracted by mini-css-extract-plugin
module.exports = {"tlr_form__row":"TokenLockingReports_tlr_form__row__1zP_Z","tlr_form__btns":"TokenLockingReports_tlr_form__btns__1dTHl"};